<template>
  <div class="network-edit-page scrollable">
    <div class="page-header">
      <h1>{{ $route.meta.title }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'tinder-accounts' }">
          Tinder Accounts
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="edit-form">
      <el-form
        :model="formData"
        status-icon
        :rules="rulesValidate"
        ref="tinderAccountEditForm"
        label-width="135px"
        class="demo-ruleForm"
      >
        <div class="row-block">
          <el-form-item label="Request count" prop="requests_count">
            <el-input
              type="text"
              v-model="formData.requests_count"
              autocomplete="off"
              class="custom-request-count"
            ></el-input>
          </el-form-item>      
          <el-form-item label="Autoscan" size="small">
            <el-radio-group v-model="formData.autoscan" class="custom-radio-autoscan">
              <el-radio-button :label="true">Autosan</el-radio-button>
              <el-radio-button :label="false">No</el-radio-button>
            </el-radio-group>
          </el-form-item>        
        </div>
        
        <div class="row-block">
          <el-form-item label="Session expired" prop="session_expired">
              <el-date-picker
                  size="small"
                  v-model="formData.session_expired"
                  :picker-options="datePickerOptions"
                  type="date"
                  format="MM-dd-yyyy"
                  value-format="yyyy-MM-dd"
                  placeholder="Select Expired Date"
                  class="custom-select-expired"
              />
          </el-form-item>      
          <el-form-item label="Created" prop="created_at">
            <el-input v-model="formData.created_at" type="text" disabled="disabled" class="custom-select-created"></el-input>
          </el-form-item>              
        </div>
      
        <div class="row-block">
          <el-form-item label="Status" size="small" prop="status">
            <el-select
                v-model="formData.status"
                placeholder="Choose"
                class="custom-select-status"
            >
              <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.text"
                  :value="item.label"
              >
              </el-option>
            </el-select>        
          </el-form-item>       
          <el-form-item label="Account group" prop="account_group_id">
            <el-select v-model="formData.account_group_id" placeholder="Group" class="custom-select-group">
              <el-option
                v-for="itm in this.tinderAccountGroups"
                :key="itm.id"
                :label="itm.age"
                :value="itm.id">
              </el-option>
            </el-select>
          </el-form-item>          
        </div>        


        <el-form-item label="User-Agent" prop="user_agent">
          <el-input
            type="text"
            v-model="formData.user_agent"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="TinderWeb Uuid" prop="web_uuid">
          <el-input
            type="text"
            v-model="formData.web_uuid"
            autocomplete="off"
          ></el-input>
        </el-form-item>    
        
        <el-form-item label="API Token" prop="api_token">
          <el-input
            type="text"
            v-model="formData.api_token"
            autocomplete="off"
          ></el-input>
        </el-form-item>  
        
        <el-form-item label="Proxy" prop="proxy_paid_id">
          <el-select v-model="formData.proxy_paid.id" @change="updateProxyPaidId" placeholder="Proxy" class="custom-select-status">
            <el-option
              v-for="itm in this.paidProxies"
              :key="itm.id"
              :label="itm.ip"
              :value="itm.id"
              class="proxy-select">
                <div class="proxy-select-dropdown">
                  <span style="font-size: smaller; margin-right: 10px;">{{ itm.id }}.</span> 
                  <div class="proxy-select-city">
                    <span>{{ itm.ip }}</span>
                    <span style="float: right;">{{ itm.city }}</span>
                  </div>  
                  <span style="font-size: smaller; margin-left: auto;">10</span>              
                </div>
                
            </el-option>
          </el-select>
        </el-form-item>        

        <div class="row-block">
          <div class="country-code-with-phone">
            <el-form-item label="Phone" prop="country_code_id">
              <el-select v-model="formData.country_code_id" placeholder="Code" :style="{ 'max-width': '80px' }">
                <el-option
                  v-for="itm in this.countries"
                  :key="itm.id"
                  :label="`+${itm.phone_code}`"
                  :value="itm.id">
                  <span style="float: left">{{ itm.name }}</span>
                  <span
                    style="
                      float: right;
                      color: var(--el-text-color-secondary);
                    "
                    >(+{{ itm.phone_code }})</span
                  >              
                </el-option>
              </el-select>
            </el-form-item>        
            <el-form-item label="" prop="phone" class="custom-phone-input">
              <el-input
                type="text"
                v-model="formData.phone"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </div>

          <el-form-item label="Provider" class="provider-input">
            <el-select v-model="formData.phone_provider_id" placeholder="Provider" :editable="true" clearable :style="{ 'max-width': '150px' }">
              <el-option
                v-for="itm in this.phoneProviders"
                :key="itm.id"
                :label="itm.name"
                :value="itm.id">
              </el-option>          
            </el-select>
          </el-form-item>
        </div>

        <el-form-item label="Email" prop="email">
          <el-input
            type="text"
            v-model="formData.email"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Notes">
          <el-input
            type="textarea"
            rows="3"
            v-model="formData.notes"
            autocomplete="off"
          ></el-input>
        </el-form-item>           
        <el-form-item label="SMS code" prop="sms_code">
            <el-input
              type="text"
              v-model="formData.sms_code"
              autocomplete="off"
              disabled="disabled"
              class="sms-input"
            >
            </el-input>
          </el-form-item>          
        <!-- <el-form-item label="Permanently blocked" size="small">
          <el-radio-group v-model="formData.permanently_blocked">
            <el-radio-button :label="true">Blocked</el-radio-button>
            <el-radio-button :label="false">Active</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Temporary blocked" size="small">
          <el-radio-group v-model="formData.temporary_blocked">
            <el-radio-button :label="true">Blocked</el-radio-button>
            <el-radio-button :label="false">Active</el-radio-button>
          </el-radio-group>
        </el-form-item> -->       
        <el-form-item label="SMS history" prop="preparedSmsHistory">
          <el-input
            type="textarea"
            rows="2"
            v-model="preparedSmsHistory"
            autocomplete="off"
          ></el-input>
        </el-form-item>        
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('tinderAccountEditForm')"
          >
            Save
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { mapGetters } from 'vuex'

let mobileValidate = (rule, value, callback) => {
  let mobReg = /^\d{11,13}$/;
  if(!mobReg.test(value)){
    callback(new Error('Invalid phone number.'));
  }else{
    callback();
  }
}

export default {
  name: 'TinderAccountsEdit',
  data() {
    return {
      // customDropdownClass: 'your-custom-class',
      // customDropdownClass: 'your-custom-class',
      formData: {
        account_group_id: null,
        proxy_paid_id: null,
        proxy_paid: {
          city: null, 
          id: null, 
          ip: null
        },
        phone_provider_id: null,
        country_code_id: 6,
        session_expired: null,
        web_uuid: null,
        user_agent: null,
        phone: '',
        api_token: '',
        email: null,
        blocked: true,
        status: null,
        autoscan: false,
        notes: "",
      },
      preparedSmsHistory: "",
      rulesValidate: {
          account_group_id: [{required: true, message: 'Choose Group', trigger: 'blur'}],
          proxy_paid_id: [
            {
              required: () => !this.formData.proxy_paid_id,
              message: 'Please choose the proxy IP',
              trigger: 'blur'
            }
          ],
          phone_provider_id: [{required: true, message: 'Please choose the phone Provider', trigger: 'blur'}],
          status: [{required: true, message: 'Please choose the Status', trigger: 'blur'}],
          country_code_id: [{required: true, message: 'Please choose the phone country', trigger: 'blur'}],
          session_expired: [{required: true, message: 'Please choose the expired date', trigger: 'blur'}],
          phone: [{required: true, validator: mobileValidate}]
      },
      datePickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: this.handleDisabledDate
      },
      statusOptions: [
        {
          value: 1,
          label: 'blocked',
          text: 'Blocked'

        },
        {
          value: 2,
          label: 'active',
          text: 'Active'
        },
        {
          value: 3,
          label: 'verification',
          text: 'Verification'
        }
      ],
      showByStatus: 1,       
    }
  },
  computed: {
    ...mapGetters({
      tinderAccountData: 'tinderAccounts/showTinderAccount',
      paidProxies: 'tinderAccounts/getPaidProxies',
      phoneProviders: 'tinderAccounts/getPhoneProviders',
      tinderAccountGroups: 'tinderAccounts/getTinderAccountGroups',
      countries: 'tinderAccounts/getCountries'
    }),
  },
  watch: {
    tinderAccountData: function (val) {
      let copy = {...this.formData, ...val}
      this.formData = copy;
      this.preparedSmsHistory = this.prepareSmsHistory(val.sms_history);
    },
    'tinderAccountData.proxy_paid.id': function (newProxyPaidId) {
      this.$nextTick(() => {
        this.$set(this.formData, 'proxy_paid_id', newProxyPaidId);
      });
    }    
  },
  created () {
    if (this.$route.params.id) {
      this.$store.dispatch('tinderAccounts/showTinderAccount', this.$route.params.id)
        .then(() => {
          if (this.tinderAccountData.proxy_paid && this.tinderAccountData.proxy_paid.id) {
            this.$nextTick(() => {
              this.$set(this.formData, 'proxy_paid_id', this.tinderAccountData.proxy_paid.id);
            });
          }
        });
    } else {
      this.$store.dispatch('tinderAccounts/clearCurrentTinderAccount');
    }
    this.$store.dispatch('tinderAccounts/getPaidProxies')
    this.$store.dispatch('tinderAccounts/getPhoneProviders')
    this.$store.dispatch('tinderAccounts/getTinderAccountGroups')
    this.$store.dispatch('tinderAccounts/getCountries')

    let copy = {...this.formData, ...this.tinderAccountData}
    this.formData = copy
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.$route.params.id) {
            this.$store.dispatch('tinderAccounts/createTinderAccount', this.formData)
            .then(response => {
                this.$notify.success('Account has been added')
                this.$router.push({name:"tinder-accounts"})
            })
            .catch(error => {
                console.log('error',error);
            })
          } else {
            this.$store.dispatch('tinderAccounts/updateTinderAccount', this.formData)
          }
        } else {
          Message({
            message: 'Form not validated',
            type: 'error',
            duration: 5 * 1000,
          })
          return false
        }
      })
    },
    handleDisabledDate(date) {
      return date <= new Date()
    },
    prepareSmsHistory(history){
      let result = '';
      history.forEach(function(item, i, arr) {
        result += 'Date: '+item.created_at+' Content: '+item.content+";\n";
      });
      return result;
    },
    updateProxyPaidId(value) {
      this.$set(this.formData, 'proxy_paid_id', value);
    },    
  }
}
</script>

<style scoped lang="scss">
.el-form-item {
    margin-bottom: 15px;
}
.el-input {
  max-width: 600px;
}
.el-input__inner {
  width: 100px !important;
}
.el-textarea {
  max-width: 600px;
}
.proxy-select {
  height: 50px;
  border-bottom: solid 1px #80808026;
  padding: 0 20px 0 10px;
  &-dropdown {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;    
  }
  &-city {
    display: flex;
    flex-direction: column;
    span {
      display: block;
      margin: -5px 0px;
    }    
  }    
}

.row-block {
  max-width: 735px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media screen and (max-width: 1030px) {
    flex-direction: column;
  }
}
.country-code-with-phone {
  display: flex;
  flex-direction: row;
}
.sms-input {
  min-width: 70px !important;
}
.provider-input {
  margin-left: -60px;
  @media screen and (max-width: 1030px) {
    margin-left: 0px;
  }  
}
.custom-phone-input {
  margin-left: -135px;
  width: 305px;
  @media screen and (max-width: 1030px) {
    width: 86%;
  }   
}
.custom-select-group {
  width: 98px;
  @media screen and (max-width: 1030px) {
    width: 100%;
  }   
}
.custom-select-created {
  width: 142px;
  @media screen and (max-width: 1030px) {
    width: 100%;
  }   
}
.custom-select-expired, .custom-request-count, .custom-select-proxy, .custom-select-status {
  width: 250px;
  @media screen and (max-width: 1030px) {
    width: 100%;
  }   
}
.custom-radio-autoscan {
    margin-left: 10px;
    @media screen and (max-width: 1030px) {
      margin-left: 0;
    }      
}
</style>
